// extracted by mini-css-extract-plugin
export default {"wrapper":"Game_wrapper__E2DIu","zoomIn":"Game_zoomIn__5+mcM","gameContainer":"Game_gameContainer__8uwod"};